"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ParkingIconSmall = ParkingIconSmall;
exports.default = ParkingIcon;
var _react = _interopRequireDefault(require("react"));
var _iconBase = _interopRequireDefault(require("./shared/icon-base"));
var _core = require("@emotion/core");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ParkingIcon(props) {
  return (0, _core.jsx)(_iconBase.default, props, (0, _core.jsx)("path", {
    d: "M23 8H20.2135L19.0156 4.11621C18.626 2.85059 17.4736 2 16.1489 2H7.85107C6.52636 2 5.37402 2.85059 4.98437 4.11572L3.78643 8H1V10H2.78027C2.30053 10.532 2 11.2289 2 12V21H4V17.9144C6.57715 18.7981 9.2594 19.25 11.9976 19.25C12.0386 19.25 12.0801 19.2495 12.1211 19.2495C14.8185 19.2367 17.4616 18.7849 20 17.9144V21H22V12C22 11.2289 21.6995 10.532 21.2197 10H23L23 8ZM6.89551 4.70508C7.02539 4.2832 7.40967 4 7.85108 4H16.1489C16.5903 4 16.9746 4.2832 17.1045 4.70557L18.429 9H5.57104L6.89551 4.70508ZM12.1113 17.2495C9.31732 17.2559 6.6012 16.7496 4 15.7698V12C4 11.4487 4.44873 11 5 11H19C19.5513 11 20 11.4487 20 12V15.7709C17.4692 16.725 14.8224 17.2364 12.1113 17.2495ZM10 14.5275V15H6.87286C6.3908 15 6 14.6092 6 14.1271V13H8.47247C9.3161 13 10 13.6839 10 14.5275ZM15.5275 13H18V14.1271C18 14.6092 17.6092 15 17.1271 15H14V14.5275C14 13.6839 14.6839 13 15.5275 13Z",
    fill: "currentColor"
  }));
}
function ParkingIconSmall(props) {
  return (0, _core.jsx)(ParkingIcon, _extends({
    size: "small"
  }, props));
}